module.exports = __webpack_public_path__ + "img/img12.6a86e04a.svg";